var _defs, _g;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgPlane = function SvgPlane(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-19.4%",
    y: "-13.9%",
    width: "138.9%",
    height: "138.9%",
    filterUnits: "objectBoundingBox",
    id: "plane_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.822463768 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "plane_svg__b",
    d: "M125 5h36v36h-36z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-121 -3)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#plane_svg__a)",
    xlinkHref: "#plane_svg__b"
  }), /*#__PURE__*/React.createElement("image", {
    x: 125,
    y: 5,
    width: 36,
    height: 36,
    xlinkHref: "data:image/png;base64,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"
  }))));
};

export { SvgPlane as ReactComponent };
export default "/_next/static/media/plane.9b5e277e.svg";